const dayIndexMap = {
  Ma: 0,
  Ti: 1,
  Ke: 2,
  To: 3,
  Pe: 4,
  La: 5,
  Su: 6,
}

const calendarSlotIndex = ({ part, week, day }) =>
  (part - 1) * 16 * 7 + (week - 1) * 7 + dayIndexMap[day]

const matchScheduleRaw = [
  { part: 1, week: 3, day: 'Pe', label: 'CC Ottelu 1 / CL Ottelu 1' },
  { part: 1, week: 4, day: 'Ma', label: 'CC Ottelu 2 / CL Ottelu 2' },
  { part: 1, week: 4, day: 'Pe', label: 'CC Ottelu 3 / CL Ottelu 3' },
  { part: 1, week: 5, day: 'Ma', label: 'CC Ottelu 4 / CL Ottelu 4' },
  { part: 1, week: 5, day: 'Pe', label: 'CC Ottelu 5 / CL Ottelu 5' },
  { part: 1, week: 6, day: 'Pe', label: 'CC Ottelu 6 / CL Ottelu 6' },
  { part: 1, week: 7, day: 'Pe', label: 'CC Ottelu 7 / CL Ottelu 7' },
  { part: 1, week: 8, day: 'Pe', label: 'CC Ottelu 8 / CL Ottelu 8' },
  { part: 1, week: 9, day: 'Pe', label: 'CC Ottelu 9 / CL Ottelu 9' },
  { part: 1, week: 10, day: 'Pe', label: 'CC Ottelu 10 / CL Ottelu 10' },
  { part: 1, week: 11, day: 'Pe', label: 'CC Puolivälierät' },
  { part: 1, week: 12, day: 'Ma', label: 'CC Välierät / VK Ottelu 1' },
  { part: 1, week: 12, day: 'Pe', label: 'CC Finaali / VK Ottelu 2' },
  { part: 1, week: 13, day: 'Pe', label: 'WC krs 1 Ottelu 1 / NC Ottelu 1' },
  { part: 1, week: 14, day: 'Ma', label: 'WC krs 1 Ottelu 2' },
  { part: 1, week: 14, day: 'Pe', label: 'WC krs 1 Ottelu 3 / NC Ottelu 2' },
  { part: 1, week: 15, day: 'Pe', label: 'WC krs 1 Ottelu 4 / NC Ottelu 3' },
  { part: 1, week: 16, day: 'Pe', label: 'WC krs 1 Ottelu 5 / NC Ottelu 4' },
  { part: 2, week: 1, day: 'Pe', label: 'WC krs 1 Ottelu 6 / NC Ottelu 5' },
  { part: 2, week: 2, day: 'Pe', label: 'WC krs 1 Ottelu 7 / NC Ottelu 6' },
  { part: 2, week: 3, day: 'Pe', label: 'WC krs 1 Ottelu 8 / NC Ottelu 7' },
  { part: 2, week: 4, day: 'Pe', label: 'WC krs 1 Ottelu 9 / NC Ottelu 8' },
  { part: 2, week: 5, day: 'Pe', label: 'WC krs 1 Ottelu 10 / NC Ottelu 9' },
  { part: 2, week: 6, day: 'Pe', label: 'WC krs 2 Ottelu 1 / NC Ottelu 10' },
  { part: 2, week: 7, day: 'Ma', label: 'WC krs 2 Ottelu 2' },
  { part: 2, week: 7, day: 'Pe', label: 'WC krs 2 Ottelu 3 / NC Ottelu 11' },
  { part: 2, week: 8, day: 'Ma', label: 'WC krs 2 Ottelu 4' },
  { part: 2, week: 8, day: 'Pe', label: 'WC krs 2 Ottelu 5 / NC Ottelu 12' },
  { part: 2, week: 9, day: 'Pe', label: 'WC krs 2 Ottelu 6 / NC Ottelu 13' },
  { part: 2, week: 10, day: 'Pe', label: 'WC krs 3 Ottelu 1 / NC Ottelu 14' },
  { part: 2, week: 11, day: 'Ma', label: 'WC krs 3 Ottelu 2' },
  { part: 2, week: 11, day: 'Pe', label: 'WC krs 3 Ottelu 3 / NC Ottelu 15' },
  { part: 2, week: 12, day: 'Pe', label: 'WC krs 4 Ottelu 1 / NC Ottelu 16' },
  { part: 2, week: 13, day: 'Ma', label: 'WC krs 4 Ottelu 2' },
  { part: 2, week: 13, day: 'Pe', label: 'WC krs 4 Ottelu 3 / NC Ottelu 17' },
  { part: 2, week: 14, day: 'Pe', label: 'WC krs 5 Ottelu 1 / NC Puolivälierät' },
  { part: 2, week: 15, day: 'Ma', label: 'WC krs 5 Ottelu 2' },
  { part: 2, week: 15, day: 'Pe', label: 'WC krs 5 Ottelu 3 / NC Välierät' },
  { part: 2, week: 16, day: 'Ma', label: 'WC Välierät' },
  { part: 2, week: 16, day: 'Pe', label: 'WC Finaali / NC Finaali' },
]

export const matchSchedule = matchScheduleRaw.map((entry, index, entries) => ({
  ...entry,
  slot: calendarSlotIndex(entry),
  gapToNext:
    index < entries.length - 1
      ? Math.max(0, calendarSlotIndex(entries[index + 1]) - calendarSlotIndex(entry))
      : 0,
}))

const resetEventsRaw = [
  { part: 1, week: 3, day: 'Ke', label: 'JH/IL palautus 100%', resetFactor: 0, nationalTargets: ['CC', 'CL'] },
  { part: 1, week: 11, day: 'Su', label: 'JH/IL palautus 100% (Vain CL)', resetFactor: 0, nationalTargets: ['CL'] },
  { part: 1, week: 13, day: 'Ke', label: 'JH/IL palautus 100% (Vain CC/CL)', resetFactor: 0, nationalTargets: ['CC', 'CL'] },
  { part: 2, week: 6, day: 'Ke', label: 'JH/IL palautus 80% (Vain WC)', resetFactor: 0.2, worldTargets: ['WC'] },
  { part: 2, week: 10, day: 'Ke', label: 'JH/IL palautus 60% (Vain WC)', resetFactor: 0.4, worldTargets: ['WC'] },
  { part: 2, week: 12, day: 'Ke', label: 'JH/IL palautus 40% (Vain WC)', resetFactor: 0.6, worldTargets: ['WC'] },
]

export const resetEvents = resetEventsRaw.map((entry, index) => ({
  ...entry,
  key: `reset-${index}`,
  slot: calendarSlotIndex(entry),
}))
